import { z } from 'zod';

import { BankruptcyCh13PrePetitionPaymentConfig, BankruptcyCh13WorkoutPlan } from '../../../loan/WorkoutPlan';
import { BaseLoanEvent } from '../../BaseLoanEvent';

/**
 * Originates a Chapter 13 bankruptcy workout plan. The handler computes the pre-petition arrearage
 * split (on `postPetitionSplitEffectiveDate`) and generates the pre-petition payment schedule.
 *
 * Phase 2 captures the pre-petition side only; the post-petition plan inputs arrive in Phase 4.
 */
export const CreateBankruptcyCh13WorkoutPlanEvent = BaseLoanEvent.extend({
  type: z.literal('createBankruptcyCh13WorkoutPlan'),
  data: BankruptcyCh13WorkoutPlan.pick({
    bankruptcyId: true,
    confirmationDate: true,
    postPetitionSplitEffectiveDate: true,
  }).extend({
    prePetitionPlan: BankruptcyCh13PrePetitionPaymentConfig.pick({
      monthlyPaymentAmount: true,
      payer: true,
      effectiveDate: true,
      numberOfMonthsRemaining: true,
    }),
  }),
});
export type CreateBankruptcyCh13WorkoutPlanEvent = z.infer<typeof CreateBankruptcyCh13WorkoutPlanEvent>;
